import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=3b3885a6&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b3885a6')) {
      api.createRecord('3b3885a6', component.options)
    } else {
      api.reload('3b3885a6', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=3b3885a6&", function () {
      api.rerender('3b3885a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O1d7lCl53ceb/JS/comp/pricelist.vue"
export default component.exports